$(() => {
    if ($('.scrolling__items')[0]) {
        const controller = new ScrollMagic.Controller();

        if ($('#trigger-1').length) {
            const scene = new ScrollMagic.Scene({ triggerElement: '#trigger-1', duration: '200%' });
            scene.setClassToggle($('#section-1')[0], 'is-on-screen').addTo(controller);
        }

        if ($('#trigger-2').length) {
            const scene = new ScrollMagic.Scene({ triggerElement: '#trigger-2', duration: '200%' });
            scene.setClassToggle($('#section-2')[0], 'is-on-screen').addTo(controller);
        }

        if ($('#trigger-3').length) {
            const scene = new ScrollMagic.Scene({ triggerElement: '#trigger-3', duration: '200%' });
            scene.setClassToggle($('#section-3')[0], 'is-on-screen').addTo(controller);
        }

        if ($('#trigger-4').length) {
            const scene = new ScrollMagic.Scene({ triggerElement: '#trigger-4', duration: '200%' });
            scene.setClassToggle($('#section-4')[0], 'is-on-screen').addTo(controller);
        }

        if ($('#trigger-5').length) {
            const scene = new ScrollMagic.Scene({ triggerElement: '#trigger-5', duration: '200%' });
            scene.setClassToggle($('#section-5')[0], 'is-on-screen').addTo(controller);
        }

        if ($('#trigger-6').length) {
            const scene = new ScrollMagic.Scene({ triggerElement: '#trigger-6', duration: '200%' });
            scene.setClassToggle($('#section-6')[0], 'is-on-screen').addTo(controller);
        }

        if ($('#trigger-7').length) {
            const scene = new ScrollMagic.Scene({ triggerElement: '#trigger-7', duration: '200%' });
            scene.setClassToggle($('#section-7')[0], 'is-on-screen').addTo(controller);
        }

        if ($('#trigger-8').length) {
            const scene = new ScrollMagic.Scene({ triggerElement: '#trigger-8', duration: '200%' });
            scene.setClassToggle($('#section-8')[0], 'is-on-screen').addTo(controller);
        }
    }
});
